import { apiCrm } from '../../../../http';

class ProtocolProcessService {
  async list(params, headers) {
    return apiCrm.get(`/protocol-process`, {
      params,
      headers
    });
  }

  async create(data) {
    return apiCrm.post(`/protocol-process`, data);
  }

  async getById(id) {
    return apiCrm.get(`/protocol-process/${id}`);
  }

  async update(id, data) {
    return apiCrm.put(`/protocol-process/${id}`, data);
  }

  async delete(id) {
    return apiCrm.delete(`/protocol-process/${id}`);
  }
}

export default new ProtocolProcessService();
